import React from 'react';
import Grid from '@mui/material/Grid';
import FormSwitch from 'layouts/projects/Forms/FormComponents/FormSwitch';
import OutlinedFormTextField from 'layouts/projects/Forms/FormComponents/OutlinedFormTextField';
import { validationSchemaKasaSheetTemplate } from 'layouts/projects/Forms/SheetTemplates/SheetTemplateForm/YupValidationSchemaSheets.js';
import { kasaToSheet, sheetToKasa } from '@samilkahraman/demand-namer';
import { BaseForm } from '../BaseForm';
import MDBox from 'components/MDBox';
import MDBadge from 'components/MDBadge';

export const KasaForm = (props) => {
    const allowedChanges = [
        'miktar',
        'en',
        'boy',
        'dumanFitili',
        'kesim45',
        'kilitKarsiligi',
        'menteseKarsiligi',
        'hidrolikKarsiligi',
        'soveMi',
    ];

    const renderFields = (formik, classes) => (
        <>
            <Grid
                container
                spacing={3}
                sx={{
                    justifyContent: 'space-between',
                }}
            >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4
                    }}>
                    <OutlinedFormTextField
                        itemID="miktar"
                        label="Miktar (Adet)"
                        placeHolder="Örn: 1000"
                        type="number"
                        formik={formik}
                        step="1"
                        adornment="AD"
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4
                    }}>
                    <OutlinedFormTextField
                        itemID="en"
                        label="En"
                        placeHolder="Örn: 82"
                        type="number"
                        formik={formik}
                        step="0.1"
                        adornment="CM"
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4
                    }}>
                    <OutlinedFormTextField
                        itemID="boy"
                        label="Boy"
                        placeHolder="Örn: 209"
                        type="number"
                        formik={formik}
                        step="0.1"
                        adornment="CM"
                    />
                </Grid>
            </Grid>
            <Grid container sx={classes.switch}>
                <FormSwitch formik={formik} name="dumanFitili" color="secondary" label="Duman Fitili" />
                <FormSwitch formik={formik} name="kesim45" color="secondary" label="45° Kesim" />
                <FormSwitch formik={formik} name="kilitKarsiligi" color="secondary" label="Kilit Karşılığı" />
                <FormSwitch formik={formik} name="menteseKarsiligi" color="secondary" label="Menteşe Karşılığı" />
                <FormSwitch formik={formik} name="hidrolikKarsiligi" color="secondary" label="Hidrolik Karşılığı" />
                <FormSwitch formik={formik} name="soveMi" color="secondary" label="Söve Mi?" />
            </Grid>
        </>
    );

    return (
        <BaseForm
            {...props}
            validationSchema={validationSchemaKasaSheetTemplate}
            allowedChanges={allowedChanges}
            toSheet={kasaToSheet}
            fromSheet={sheetToKasa}
            renderFields={renderFields}
        />
    );
};

export const KasaBadges = (props) => {
    const { initial } = props;
    const values = sheetToKasa(initial);
    const toBadge = (degisken, aciklama, renk = 'dark') => {
        return (
            <MDBox>
                <MDBadge
                    m={1}
                    badgeContent={`${aciklama}: ${values[degisken] !== undefined ? values[degisken] : '-'}`}
                    size="xs"
                    container
                    variant="gradient"
                    color={renk}
                />
            </MDBox>
        );
    };
    return (
        <Grid
            container
            spacing={3}
            sx={{
                justifyContent: 'space-between',
            }}
        >
            <Grid size={12}>
                <MDBox display="flex" flexDirection="row" justifyContent="space-evenly" flexWrap="wrap">
                    {toBadge('kalinlik', 'Kalınlık', 'secondary')}
                    {toBadge('cins', 'Cins', 'secondary')}
                    {toBadge('cinsAciklama', 'Cins Açıklama', 'secondary')}
                    {toBadge('yapi', 'Yapı', 'secondary')}
                    {toBadge('lambaDerinlik', 'Lamba Derinlik', 'secondary')}
                    {toBadge('lambaGenislik', 'Lamba Genişlik', 'secondary')}
                    {toBadge('koseliBombeli', 'Köşeli/Bombeli', 'secondary')}
                    {toBadge('fitil', 'Fitil', 'secondary')}
                    {toBadge('pervazKanalGenisligi', 'Pervaz Kanal Genişliği', 'secondary')}
                    {toBadge('pervazKanalDerinligi', 'Pervaz Kanal Derinliği', 'secondary')}
                    {toBadge('girinti', 'Girinti', 'secondary')}
                    {toBadge('ozelProfilTipi', 'Özel Profil Tipi', 'secondary')}
                    {toBadge('ozelProfilAciklama', 'Özel Profil Açıklama', 'secondary')}
                    {toBadge('ekNot', 'NOTLAR: ', 'dark')}
                </MDBox>
            </Grid>
        </Grid>
    );
};
